import { useState, useCallback } from 'react';

/**
 * Hook para gerenciar navegação hierárquica dos efeitos
 * Níveis: categorias -> efeitos -> detalhes
 */
export const useEffectNavigation = () => {
  // Estado da navegação
  const [currentLevel, setCurrentLevel] = useState('categories'); // 'categories', 'effects', 'details'
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedEffect, setSelectedEffect] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [direction, setDirection] = useState('forward'); // 'forward' (direita->esquerda) | 'back' (esquerda->direita)

  // Navegar para lista de efeitos de uma categoria
  const navigateToEffects = useCallback((categoryId, categoryName, effects) => {
    setSelectedCategory({ id: categoryId, name: categoryName, effects });
    setCurrentLevel('effects');
    setDrawerOpen(true);
    setDirection('forward');
    setIsAnimating(true);
    
    // Reset animação após transição
    setTimeout(() => setIsAnimating(false), 300);
  }, []);

  // Navegar para detalhes de um efeito
  const navigateToEffectDetails = useCallback((effectId) => {
    setSelectedEffect(effectId);
    setCurrentLevel('details');
    setDirection('forward');
    setIsAnimating(true);
    
    // Reset animação após transição
    setTimeout(() => setIsAnimating(false), 300);
  }, []);

  // Voltar para lista de categorias
  const navigateBackToCategories = useCallback(() => {
    setDirection('back');
    setIsAnimating(true);
    
    setTimeout(() => {
      setCurrentLevel('categories');
      setSelectedCategory(null);
      setSelectedEffect(null);
      setDrawerOpen(false);
      setIsAnimating(false);
    }, 150); // Animação mais rápida para voltar
  }, []);

  // Voltar para lista de efeitos (do detalhe para a categoria)
  const navigateBackToEffects = useCallback(() => {
    setDirection('back');
    setIsAnimating(true);
    
    setTimeout(() => {
      setCurrentLevel('effects');
      setSelectedEffect(null);
      setIsAnimating(false);
    }, 150);
  }, []);

  // Fechar drawer completamente
  const closeDrawer = useCallback(() => {
    setIsAnimating(true);
    
    setTimeout(() => {
      setCurrentLevel('categories');
      setSelectedCategory(null);
      setSelectedEffect(null);
      setDrawerOpen(false);
      setIsAnimating(false);
    }, 150);
  }, []);

  // Reset completo do estado
  const resetNavigation = useCallback(() => {
    setCurrentLevel('categories');
    setSelectedCategory(null);
    setSelectedEffect(null);
    setDrawerOpen(false);
    setIsAnimating(false);
  }, []);

  return {
    // Estado atual
    currentLevel,
    selectedCategory,
    selectedEffect,
    drawerOpen,
    isAnimating,
    direction,
    
    // Ações de navegação
    navigateToEffects,
    navigateToEffectDetails,
    navigateBackToCategories,
    navigateBackToEffects,
    closeDrawer,
    resetNavigation
  };
};

export default useEffectNavigation;
